import { render } from "./UserProfiles.vue?vue&type=template&id=5c29b4a4&scoped=true"
const script = {}

import "./UserProfiles.vue?vue&type=style&index=0&id=5c29b4a4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c29b4a4"]])

export default __exports__